<template>
    <div>
        <label for="nombreProveedor">Nombre Proveedor</label>
        <input  autocomplete="off" required="required" id="nombreProveedor" ref="nombre" @input="$emit('input', $event.target.value)" type="text">
        <i class="bar"></i>
    </div>
</template>

<script>
    export default {
        name: "inputNombreProveedor",
    }
</script>

<style scoped>
    label{
        font-weight: bold;
    }
    input {
        width: 100%;
    }
    i{
        width: 100%;
    }
</style>
